/**
 * Build » design » version-diff-viewer (`/design/version-diff-viewer/**`).
 */
export function buildPipelineVersionDiffViewerUrl(
  realm: string,
  pipelineName: string,
  versionTo: string
): string {
  const query = new URLSearchParams({ versionTo });
  return `/${encodeURIComponent(realm)}/design/version-diff-viewer/pipeline/${encodeURIComponent(pipelineName)}?${query.toString()}`;
}

/** Redirect target for the legacy route without `/pipeline/` (handled by router). */
export function buildLegacyDesignVersionDiffViewerUrl(
  realm: string,
  pipelineName: string,
  versionTo: string
): string {
  const query = new URLSearchParams({ versionTo });
  return `/${encodeURIComponent(realm)}/design/version-diff-viewer/${encodeURIComponent(pipelineName)}?${query.toString()}`;
}
